import { request } from '../../utils'

// These endpoints are still on API v1, which only returns JSON when explicitly
// asked via `format=json&raw=1`. The new fetch layer no longer injects those, so
// we pass them here until these calls are migrated to `/api/2/...`.
const V1_JSON = { format: 'json', raw: '1' }

// NOTE: the new fetch layer has no upload-progress support, so `onProgress` is no
// longer honored. The upload still completes; only the progress indicator is lost.
export const uploadHandout = (liveId, file) => {
  return request({
    url: '/api/live/attachment/upload',
    method: 'POST',
    files: { file },
    data: {
      live_id: liveId,
      ...V1_JSON,
    },
  })
}

export const fetchHandouts = (liveId, token) => {
  return request({
    url: '/api/live/attachment/list',
    method: 'GET',
    data: {
      live_id: liveId,
      token,
      ...V1_JSON,
    },
  })
}

export const removeHandout = (liveId, filename) => {
  return request({
    url: '/api/live/attachment/delete',
    method: 'POST',
    data: {
      live_id: liveId,
      filename,
      ...V1_JSON,
    },
  })
}
